import { OverDuePendingReq } from '@gtpl/shared-models/sale-management'
import { SaleOrderService } from '@gtpl/shared-services/sale-management'
import { Button, Card, Col, DatePicker, Form, message, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import dayjs from "dayjs";
import moment from 'moment';
 
const OverDuePendingOrderReport = () => {

const saleService=new SaleOrderService()
const [pendingData,setPendingData]=useState<any>()
const [monthPendingData,setMonthPendingData]=useState<any>([])
const { MonthPicker } = DatePicker;
const [form] = Form.useForm();
const [firstMonth, setFirstMonth] = useState<string>("");
const [firstMonthYear, setFirstMonthYear] = useState<string>("");
const [secondMonth, setSecondMonth] = useState<string>("");
const [thirdMonth, setThirdMonth] = useState<string>("");
const [fourthMonth, setFourthMonth] = useState<string>("");
const [fifthMonth, setFifthMonth] = useState<string>("");
const [isFiltered,setIsFiltered]=useState<boolean>(false)
const [displayMonth, setDisplayMonth] = useState<string>("");

const getOverduePendingOrderReport = (date: moment.Moment | null) => {
    if (!date) {
      message.error("Please select a valid month");
      return;
    }
    const startMonth = date.month() + 1; 
    const startYear = date.year();
    const req = new OverDuePendingReq(startMonth, startYear);
  
    saleService.getOverduePendingOrderReport(req).then((res) => {
      if (res.status) {
        setPendingData(res.data);
      }
    });
  };

  const getMonthWiseOverdueReport = (date: moment.Moment | null) => {
    if (!date) {
      message.error("Please select a valid month");
      return;
    }
    const startMonth = date.month() + 1; 
    const startYear = date.year();
    const req = new OverDuePendingReq(startMonth, startYear);
  
    saleService.getMonthWiseOverdueReport(req).then((res) => {
      if (res.status) {
        setMonthPendingData(res.data);
      }else{
        setMonthPendingData([])
      }
    });
  };

  const getReport = (date) => {
    if (!date) {
      message.error("Please select a valid month");
      return;
    }
  
    getOverduePendingOrderReport(date);
    getMonthWiseOverdueReport(date);
  
    const baseDate = moment(date);
    setDisplayMonth(baseDate.format("MMMM"));

    setFirstMonth(baseDate.clone().subtract(1, "month").format("MMMM"));
    setFirstMonthYear(baseDate.format("MMMM YYYY"));
    setSecondMonth(baseDate.clone().subtract(2, "month").format("MMMM"));
    setThirdMonth(baseDate.clone().subtract(3, "month").format("MMMM"));
    setFourthMonth(baseDate.clone().subtract(4, "month").format("MMMM"));
    setFifthMonth(baseDate.clone().subtract(5, "month").format("MMMM"));

    setIsFiltered(true);
  };
  
  const calculateTotals = (data) => {
    let totals = {
      firstMonth: 0,
      secondMonth: 0,
      thirdMonth: 0,  
      fourthMonth: 0,
      fifthMonth: 0,
      remainingMonth:0,
      totalSaleOrders:0
    };
    data?.forEach(rec => {
      const firstMonth = rec.firstMonth !== null ? parseFloat(rec.firstMonth) : 0;
      const secondMonth = rec.secondMonth !== null ? parseFloat(rec.secondMonth) : 0;
      const thirdMonth = rec.thirdMonth !== null ? parseFloat(rec.thirdMonth) : 0;
      const fourthMonth = rec.fourthMonth !== null ? parseFloat(rec.fourthMonth) : 0;
      const fifthMonth = rec.fifthMonth !== null ? parseFloat(rec.fifthMonth) : 0;
      const remainingMonth = rec.remainingMonth !== null ? parseFloat(rec.remainingMonth) : 0;

      const totalSaleOrders = rec.totalSaleOrders !== null ? parseFloat(rec.totalSaleOrders) : 0;

      totals.firstMonth += firstMonth;
      totals.secondMonth += secondMonth;
      totals.thirdMonth += thirdMonth;
      totals.fourthMonth += fourthMonth;
      totals.fifthMonth += fifthMonth;
      totals.remainingMonth+=remainingMonth
    totals.totalSaleOrders+=totalSaleOrders
    });
    return totals;
  };
  
  const totalsData = calculateTotals(pendingData);

  return (
    <div>
         <Card
      title={<span style={{ color: 'white' }}>Overdue Pending Orders Report</span>}
      extra = {isFiltered && (
        <ReactHTMLTableToExcel
        id='excel-button'
        className='download-table-xls-button'
        table='combined-report-table'
        filename='overdue-pending-order-report'
        sheet="overdue-pending-order-report"
        buttonText='Get Excel'
  
              />
            ) }      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
       <Form form={form}>
        <Row gutter={18}>
            <Col span={6}>
            <Form.Item name="month" label="Month" rules={[{
                                  required: true,
                                  message: 'Input is required',
                                },
                              ]}
                            >
                              <MonthPicker
                                format="MM-YYYY"
                                style={{ width: '100%' }}
                                onChange={(date) => getReport(date)}
                              />
                            </Form.Item>
            </Col>
        </Row>
       </Form>
                  <table id="combined-report-table" style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '100%' }}>
    <tbody>
      <tr>
        <td>
             {isFiltered &&(
            <table id='report-table' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '100%' }}>
              <tr >
                <th style={{ textAlign: 'center', fontSize: '18px', border: '1px solid black' }} colSpan={9}>OVERDUE PENDING SALES ORDER {(firstMonthYear)?.toUpperCase()}</th></tr>
            <tr>
            <th style={{ textAlign: 'center', fontSize: '18px', border: '1px solid black' }} colSpan={9}>PENDING ORDERS DUES AS ON {(firstMonthYear)?.toUpperCase()}</th>
            </tr>
            <tr style={{ backgroundColor: 'lightblue' }}>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>0-29</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>30-59</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>60-89</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>90-119</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>120-149</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>149+</th>

                <th style={{ textAlign: 'center', border: '1px solid black' }}>Grand Total</th>
            </tr>
            {pendingData?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.firstMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.secondMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.thirdMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.fourthMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.fifthMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.remainingMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.totalSaleOrders}</td>
                    </tr>
                )
            })}
            <tfoot>
                <tr>
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>Grand Total</th>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.firstMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.secondMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.thirdMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.fourthMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.fifthMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.remainingMonth}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black',color:"red" }}>{totalsData.totalSaleOrders}</td>
                </tr>
            </tfoot>
        </table>
        )}
        <br />
        {isFiltered &&(
        <table id='report-table1' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '80%' }}>
            <tr style={{ textAlign: 'center', border: '1px solid black',backgroundColor: '#f9b466'  }} >
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={5}>{firstMonth}</th></tr>
        <tr>
        <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>No Of Containers</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Weight(In KGS)</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Amount In USD</th>
        </tr>
        {monthPendingData?.firstMonth?.data?.map((rec, idx) => {
    return (
        <tr key={idx}>
            <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
            <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
            <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.saleOrders}</td>
            <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.netWeight}</td>
            <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.amount}</td>
        </tr>
    );
})}
<tfoot>
    <tr>
        <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>TOTAL</th>
        <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.firstMonth?.totalSaleOrders}</td>
        <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.firstMonth?.totalNetWeight}</td>
        <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.firstMonth?.totalAmount}</td>
    </tr>
</tfoot>

        </table>
         )}
        <br />
        {isFiltered &&(
        <table id='report-table2' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '80%' }}>
        <tr style={{ textAlign: 'center', border: '1px solid black',backgroundColor: '#f9b466' }} >
            <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={5}>{secondMonth}</th></tr>

        <tr>

        <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>No Of Containers</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Weight(In KGS)</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Amount In USD</th>
        </tr>
            {monthPendingData?.secondMonth?.data?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.saleOrders}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.netWeight}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.amount}</td>

                    </tr>
                )
            })}
             <tfoot>
                <tr>
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>TOTAL</th>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.secondMonth?.totalSaleOrders}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.secondMonth?.totalNetWeight}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.secondMonth?.totalAmount}</td>
                </tr>
            </tfoot>
        </table>
         )}
        <br />
        {isFiltered &&(
        <table id='report-table3' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '80%' }}>
        <tr style={{ textAlign: 'center', border: '1px solid black',backgroundColor: '#f9b466' }}><th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={5}>{thirdMonth}</th></tr>

        <tr>
        <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>No Of Containers</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Weight(In KGS)</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Amount In USD</th>
        </tr>
            {monthPendingData?.thirdMonth?.data?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.saleOrders}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.netWeight}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.amount}</td>

                    </tr>
                )
            })}
             <tfoot>
                <tr>
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>TOTAL</th>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.thirdMonth?.totalSaleOrders}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.thirdMonth?.totalNetWeight}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.thirdMonth?.totalAmount}</td>
                </tr>
            </tfoot>
        </table>
         )}
        <br />
        {isFiltered &&(
        <table id='report-table4' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '80%' }}>
        <tr style={{ textAlign: 'center', border: '1px solid black',backgroundColor: '#f9b466' }}><th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={5}>{fourthMonth}</th></tr>

        <tr>
        <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>No Of Containers</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Weight(In KGS)</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Amount In USD</th>
        </tr>
            {monthPendingData?.fourthMonth?.data?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.saleOrders}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.netWeight}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.amount}</td>

                    </tr>
                )
            })}
             <tfoot>
                <tr>
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>TOTAL</th>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.fourthMonth?.totalSaleOrders}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.fourthMonth?.totalNetWeight}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.fourthMonth?.totalAmount}</td>
                </tr>
            </tfoot>
        </table>
         )}
        <br />
        {isFiltered &&(
        <table id='report-table5' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '80%' }}>
        <tr style={{ textAlign: 'center', border: '1px solid black',backgroundColor: '#f9b466' }}><th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={5}>{fifthMonth}</th></tr>

        <tr>
        <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>No Of Containers</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Weight(In KGS)</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Amount In USD</th>
        </tr>
            {monthPendingData?.fifthMonth?.data?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.saleOrders}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.netWeight}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.amount}</td>

                    </tr>
                )
            })}
             <tfoot>
                <tr>
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>TOTAL</th>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.fifthMonth?.totalSaleOrders}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.fifthMonth?.totalNetWeight}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.fifthMonth?.totalAmount}</td>
                </tr>
            </tfoot>
        </table>
          )}
           <br />
        {isFiltered &&(
        <table id='report-table5' style={{ borderCollapse: 'collapse', borderBlockColor: 'black', width: '80%' }}>
        <tr style={{ textAlign: 'center', border: '1px solid black',backgroundColor: '#f9b466' }}><th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={5}>Before 5 Months</th></tr>

        <tr>
        <th style={{ textAlign: 'center', border: '1px solid black' }}>Customer Name</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Country</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>No Of Containers</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Weight(In KGS)</th>
                <th style={{ textAlign: 'center', border: '1px solid black' }}>Amount In USD</th>
        </tr>
            {monthPendingData?.remainingMonth?.data?.map((rec,idx)=>{
                return(
                    <tr key={idx}>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.endCustomerName}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.country}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.saleOrders}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.netWeight}</td>
                        <td style={{ textAlign: 'center', border: '1px solid black' }}>{rec.amount}</td>

                    </tr>
                )
            })}
             <tfoot>
                <tr>
                <th style={{ textAlign: 'center', border: '1px solid black' }} colSpan={2}>TOTAL</th>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.remainingMonth?.totalSaleOrders}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.remainingMonth?.totalNetWeight}</td>
                <td style={{ textAlign: 'center', border: '1px solid black' }}>{monthPendingData?.remainingMonth?.totalAmount}</td>
                </tr>
            </tfoot>
        </table>
          )}
           </td>
      </tr>
    </tbody>
  </table>
    </Card>
    </div>
  )
}

export default OverDuePendingOrderReport
